/** @jsxImportSource react */

import { useShare } from '@common/helpers/share';
import OutOfBudgetWidget from '@react/gwizzy/components/OutOfBudgetWizard/OutOfBudgetWidget';
import { useRouter } from 'next/router';

import { ToolHero } from './Styles';
import { ToolDetails } from '../types';

export default function PersonalizedSeniorlyLivingOptions({
  heading,
  description,
  shortDescription,
}: ToolDetails) {
  const { query, push, pathname, asPath } = useRouter();
  const { adl, city, state, locationString, budgetRange } = query || {};

  const { share } = useShare();

  const handleSubmit = (values: any) => {
    const filters: {
      state?: string;
      city?: string;
    } = {};
    const searchParams = values?.location?.searchParams;

    if (searchParams?.state) {
      filters.state = searchParams.state;
    }
    if (searchParams?.city) {
      filters.city = searchParams.city;
    }
    const locationString = values?.location?.displayText;

    push(
      {
        pathname,
        query: {
          ...query,
          ...filters,
          adl: values?.adl,
          budgetRange: values?.budgetRange,
          locationString: locationString,
        },
      },
      undefined,
      { shallow: true }
    );
  };

  const initialOptions: {
    adl?: string;
    location?: {
      searchParams: {
        city: string;
        state: string;
      };
    };
    budgetRange?: string;
  } = {};

  if (adl) {
    initialOptions.adl = adl as string;
  }

  if (city && state) {
    initialOptions.location = {
      searchParams: {
        city: city as string,
        state: state as string,
      },
    };
  }

  return (
    <>
      <ToolHero
        heading={heading}
        subheading={description}
        onShare={() => {
          share({
            title: heading,
            text: shortDescription || description || '',
            url: `${window.location.origin}${asPath}`,
          });
        }}
      />
      <div className='mx-auto max-w-3xl'>
        <OutOfBudgetWidget
          initialOptions={{
            city: city as string,
            state: state as string,
            locationString,
            budgetRange,
            adl,
          }}
          isLocalStorageEnabled={false}
          onSubmitCallback={handleSubmit}
          className='min-h-[calc(100vh-20rem)] '
          eventProps={{
            location: `${heading} tool`,
            text: 'clicked on out of budget wizard',
          }}
        />
      </div>
    </>
  );
}
